import React, { useState, useEffect } from "react";
import { useCart } from "../context/CartContext";

export default function CartExpiryToast() {
  const { cartExpiring, dismissExpiry, clearCart } = useCart();
  const [countdown, setCountdown] = useState(60);

  useEffect(() => {
    if (!cartExpiring) {
      setCountdown(60);
      return;
    }
    const t = setInterval(() => {
      setCountdown((c) => (c > 0 ? c - 1 : 0));
    }, 1000);
    return () => clearInterval(t);
  }, [cartExpiring]);

  const handleClearNow = () => {
    clearCart({ clearSource: "cart_expiry_prompt" });
    dismissExpiry();
  };

  if (!cartExpiring) return null;

  return (
    <>
    <style>{`@keyframes toast-fade-in { from { opacity: 0; } to { opacity: 1; } }`}</style>
    <div style={styles.overlay}>
      <div style={styles.toast} role="alertdialog" aria-modal="true" aria-labelledby="cart-expiry-title" aria-describedby="cart-expiry-sub">
        <p id="cart-expiry-title" style={styles.title}>Still ordering?</p>
        <p id="cart-expiry-sub" style={styles.sub}>
          Cart will clear in <strong style={styles.count}>{countdown}s</strong>
        </p>
        <button style={styles.btn} onClick={() => dismissExpiry({ dismissSource: "keep_cart_button" })}>
          Yes, keep my cart
        </button>
        <button style={styles.clearBtn} onClick={handleClearNow}>
          No, clear cart
        </button>
      </div>
    </div>
    </>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 9999,
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "var(--bt-font)",
    animation: "toast-fade-in 0.3s ease",
  },
  toast: {
    background: "#fff",
    borderRadius: 20,
    padding: "28px 32px",
    textAlign: "center",
    maxWidth: 320,
    width: "calc(100% - 48px)",
    boxShadow: "0 16px 48px rgba(0,0,0,0.2)",
  },
  title: {
    margin: "0 0 6px",
    fontSize: 20,
    fontWeight: 800,
    color: "#1B3C59",
  },
  sub: {
    margin: "0 0 20px",
    fontSize: 15,
    fontWeight: 500,
    color: "#5d7481",
  },
  count: {
    color: "#c0392b",
    fontWeight: 800,
    fontVariantNumeric: "tabular-nums",
  },
  btn: {
    width: "100%",
    border: "none",
    background: "linear-gradient(135deg, #1B3C59 0%, #234b6e 100%)",
    color: "#fff",
    fontSize: 15,
    fontWeight: 700,
    fontFamily: "var(--bt-font)",
    padding: "14px 24px",
    borderRadius: 999,
    cursor: "pointer",
  },
  clearBtn: {
    width: "100%",
    minHeight: 44,
    marginTop: 6,
    border: "none",
    background: "transparent",
    color: "#44525c",
    fontSize: 14,
    fontWeight: 700,
    fontFamily: "var(--bt-font)",
    padding: "10px 24px",
    cursor: "pointer",
  },
};
